import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { detectBrand } from './brandConfig';

const BrandContext = createContext(null);

export function BrandProvider({ children }) {
  const brand = useMemo(() => detectBrand(), []);

  useEffect(() => {
    document.title = brand.fullName + ' · Kursplaner';
  }, [brand]);

  return (
    <BrandContext.Provider value={brand}>
      {children}
    </BrandContext.Provider>
  );
}

export function useBrand() {
  const ctx = useContext(BrandContext);
  if (!ctx) throw new Error('useBrand must be used within BrandProvider');
  return ctx;
}

// Komfort-Hook: pruefe, ob ein Bereich fuer den aktuellen Tenant aktiv ist
export function useHasRoute(routeKey) {
  const brand = useBrand();
  return !!brand.routes[routeKey];
}
